// src/api/surveyAPI.ts

const BASE_URL = process.env.REACT_APP_API_URL || 'https://hangover-survey-app.wordme.workers.dev';


export const submitSurvey = async (surveyData: any): Promise<string> => {
  try {
    const response = await fetch(`${BASE_URL}/api/survey`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...surveyData,
        timestamp: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to submit survey: ${response.statusText}`);
    }

    const data = await response.json();
    return data.resultId; // <-- IMPORTANT! Your Worker must return a { resultId: "abc123" }
  } catch (error) {
    console.error('Error in submitSurvey:', error);
    throw error;
  }
};

export const fetchResultById = async (resultId: string) => {
  try {
    const response = await fetch(`${BASE_URL}/api/results/${resultId}`);

    if (!response.ok) {
      throw new Error(`Failed to fetch result: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in fetchResultById:', error);
    throw error;
  }
};
